import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { assetExplorerApiRef, AssetExplorerClient } from './api';
import { rootRouteRef } from './routes';

export const assetExplorerPlugin = createPlugin({
  id: 'asset-explorer',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: assetExplorerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new AssetExplorerClient(discoveryApi, fetchApi, identityApi),
    }),
  ],
});

export const AssetExplorerPage = assetExplorerPlugin.provide(
  createRoutableExtension({
    name: 'AssetExplorerPage',
    component: () =>
      import('./pages/AssetExplorerPage').then(m => m.AssetExplorerPage),
    mountPoint: rootRouteRef,
  }),
);
